import { Producer } from "./producer";
import producerService from "./producerService";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import ProducerConfiguration, { ProducerDefaults } from "./producerConfiguration";
import trackApiCall, { trackApiCallNew } from "features/saveIndicator/trackApiCall";
import ProducerBulkUploadResponse from "./uploadProducersResponse"
import { UpdateAllProducersRequest } from "./updateAllProducers";
import { Dispatch } from "redux";

export class ProducersLoaded extends Event {
  constructor(public producers: Producer[]) {
    super(ProducersLoaded.EventName);
  }

  public static EventName: string = "PRODUCERS_LOADED";
}


export class ProducerAdded extends Event {
  constructor(public newProducer: Producer) {
    super(ProducerAdded.EventName);
  }

  public static EventName: string = "PRODUCER_ADDED";
}

export class ProducerUpdated extends Event {
  constructor(public producer: Producer) {
    super(ProducerUpdated.EventName);
  }

  public static EventName: string = "PRODUCER_UPDATED";
}
export class ProducerConfigurationLoaded extends Event {
  constructor(public configuration: ProducerConfiguration) {
    super(ProducerConfigurationLoaded.EventName);
  }

  public static EventName: string = "PRODUCER_CONFIGURATION_LOADED";
}

export class ProducerDeleted extends Event {
  constructor(public producer: Producer) {
    super(ProducerDeleted.EventName);
  }

  public static EventName: string = "PRODUCER_DELETED";
}

export class ProducersUploaded extends Event {
  constructor(public producerBulkUploadResponse: ProducerBulkUploadResponse) {
    super(ProducersUploaded.EventName);
  }

  public static EventName: string = "PRODUCERS_UPLOADED";
}

export class ProducersImported extends Event {
  constructor(public producerBulkUploadResponse: ProducerBulkUploadResponse) {
    super(ProducersImported.EventName);
  }

  public static EventName: string = "PRODUCERS_IMPORTED";
}

export class AllProducersUpdated extends Event {
  constructor(public producers: any) {
    super(AllProducersUpdated.EventName);
  }

  public static EventName: string = "ALL_PRODUCERS_UPDATED";
}

export class ProducerDefaultsUpdated extends Event {
  constructor(public producerDefaults: ProducerDefaults) {
    super(ProducerDefaultsUpdated.EventName);
  }

  public static EventName: string = "PRODUCER_DEFAULTS_UPDATED";
}


export function loadProducers(location?: string, trader?: string, status?: string): ActionWithDispatch<Promise<Producer[]>> {
  return function (dispatch: any) {
    return producerService
      .listProducers(location, trader, status)
      .then(producers => dispatch(new ProducersLoaded(producers).toObject()));
  };
}

export function loadProducerConfiguration(): ActionWithDispatch<Promise<ProducerConfiguration>> {
  return function(dispatch: any) {
    return producerService
      .getProducerConfiguration()
      .then(data => dispatch(new ProducerConfigurationLoaded(data).toObject()));
  };
}

export function createProducer(producer: Producer): ActionWithDispatch<Promise<any>> {
  return trackApiCall(dispatch => producerService.createProducer(producer)
      .then(p => dispatch(new ProducerAdded(p).toObject()))
  );
}

export function createProducer_dispatch(dispatch: Dispatch, producer: Producer): Promise<Producer> {
  return trackApiCallNew(dispatch, async innerDispatch => {
    const newProducer = await producerService.createProducer(producer);
    innerDispatch(new ProducerAdded(newProducer).toObject());
    return newProducer;
  });
}

export function updateProducer(newValue: Producer, oldValue: Producer): ActionWithDispatch<Promise<any>> {
  return trackApiCall(dispatch => producerService
      .updateProducer(newValue)
      .then(() => dispatch(new ProducerUpdated(newValue).toObject()))
      .catch((error) => {
        dispatch(new ProducerUpdated(oldValue).toObject());
        throw error;
      })
  );
}

export function updateProducerContact(dispatch: Dispatch, newValue: Producer, oldValue: Producer): Promise<any> {
  return trackApiCallNew(dispatch, innerDispatch => {
    innerDispatch(new ProducerUpdated(newValue).toObject());
    return producerService
      .updateProducerContact(newValue)
      .catch((error) => {
        dispatch(new ProducerUpdated(oldValue).toObject());
        throw error;
      });
  });
}

export function updateProducerStatus(producer: Producer): ActionWithDispatch<Promise<any>> {
  return (dispatch: any) => dispatch(new ProducerUpdated(producer).toObject());
}

export function deleteProducer(producer: Producer): ActionWithDispatch<Promise<any>> {
  return trackApiCall(async dispatch => {
    return producerService.deleteProducer(producer)
      .then(() => dispatch(new ProducerDeleted(producer).toObject()));
  });
}

export function uploadProducers(selectedFile: any): ActionWithDispatch<Promise<any>> {
  return function (dispatch: any) {
    return producerService
      .uploadProducers(selectedFile)
      .then(producerBulkUploadResponse => dispatch(new ProducersUploaded(producerBulkUploadResponse).toObject()));
  };
}

export function importProducers(selectedFile: any): ActionWithDispatch<Promise<any>> {
  return function (dispatch: any) {
    return producerService
      .importProducers(selectedFile)
      .then(producerBulkUploadResponse => dispatch(new ProducersImported(producerBulkUploadResponse).toObject()));
  };
}


export function updateAllProducers(allProducersRqst:UpdateAllProducersRequest): ActionWithDispatch<Promise<any>> {
  return function (dispatch: any) {
    return producerService
      .updateAllProducers(allProducersRqst)
      .then(response => dispatch(new AllProducersUpdated(response).toObject()));
  };
}

export function updateProducerDefaults(newValue: ProducerDefaults, oldValue: ProducerDefaults): ActionWithDispatch<Promise<any>> {
  return trackApiCall(dispatch => {
    dispatch(new ProducerDefaultsUpdated(newValue).toObject());
    return producerService
      .updateProducerDefaults(newValue)
      .catch((error) => {
        dispatch(new ProducerDefaultsUpdated(oldValue).toObject());
        throw error;
      });
  });
}